import ls from '@/utils/Storage'
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import baseService from '@/utils/http/axios'

dayjs.extend(utc)
dayjs.extend(timezone)

export function clearUserInfo() {
    ls.remove('ACCESS_TOKEN')
    ls.remove('PERMISSION')
    ls.remove('USER_INFO')
    ls.remove('MENU_NAV')
}

export function timeFix() {
    const time = new Date()
    const hour = time.getHours()
    return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好'
}
export const getWeek = (week: number, useZhou) => {
    let txt = ''
    switch (week) {
        case 1:
            txt = '一'
            break
        case 2:
            txt = '二'
            break
        case 3:
            txt = '三'
            break
        case 4:
            txt = '四'
            break
        case 5:
            txt = '五'
            break
        case 6:
            txt = '六'
            break
        case 0:
            txt = '日'
            break
        default:
            return 'getWeekError'
    }
    return useZhou ? '周' : '星期' + txt
}
export const mobileRequiredValidator = (rule, value) => {
    let reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
    if (value && value.length > 0) {
        if (!reg_tel.test(value)) {
            return Promise.reject('请输入正确的手机号码');
        } else {
            return Promise.resolve();
        }
    } else {
        return Promise.reject('请输入手机号码');
    }
}
export const mobileOrLandlineRequiredValidator = (rule, value) => {
    let reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
    let reg_landline = /^0\d{2,3}-?\d{7,8}$/
    if (value && value.length > 0) {
        if (!reg_tel.test(value) && !reg_landline.test(value)) {
            return Promise.reject('请输入正确的手机号码或座机号码');
        } else {
            return Promise.resolve();
        }
    } else {
        return Promise.reject('请输入手机号码');
    }
}
export const mobileValidator = (rule, value) => {
    let reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
    if (value && value.length > 0) {
        if (!reg_tel.test(value)) {
            return Promise.reject('请输入正确的手机号码');
        } else {
            return Promise.resolve();
        }
    }
    return Promise.resolve();
}

export const trimAll = (ele) => {
    if (typeof ele === 'string') {
        return ele.split(/[\t\r\f\n\s]*/g).join('');
    } else {
        return ele
    }
}

export const isEmpty = (val) => {
    if (val && val.length > 0) {
        return val
    } else {
        return '无'
    }
}

//从身份证获取年龄
export const getAgeByIdCard = (idCard) => {
    let age = 0
    if (idCard.length === 18) {
        let birth = idCard.substring(6, 14)
        let year = parseInt(birth.substring(0, 4))
        let month = parseInt(birth.substring(4, 6))
        let day = parseInt(birth.substring(6, 8))
        let now = new Date()
        let nowYear = now.getFullYear()
        let nowMonth = now.getMonth() + 1
        let nowDay = now.getDate()
        age = nowYear - year
        if (nowMonth < month) {
            age = age - 1
        }
        if (nowMonth === month && nowDay < day) {
            age = age - 1
        }
    } else {
        age = 0
    }
    return age
}

//解析地址的类
class CommercialAddressParser {
    // 添加属性声明
    private commonSurnames: Set<string>;
    private compoundSurnames: Set<string>;
    private addressKeywords: Set<string>;
    private nameKeywords: Set<string>;
    private nameSuffixes: Set<string>;
    constructor() {
        // 商用级姓氏库 - 包含中国最常见的500+个姓氏
        this.commonSurnames = new Set([
            // 前100大姓（按人口数量排序）
            '李', '王', '张', '刘', '陈', '杨', '赵', '黄', '周', '吴',
            '徐', '孙', '胡', '朱', '高', '林', '何', '郭', '马', '罗',
            '梁', '宋', '郑', '谢', '韩', '唐', '冯', '于', '董', '萧',
            '程', '曹', '袁', '邓', '许', '傅', '沈', '曾', '彭', '吕',
            '苏', '卢', '蒋', '蔡', '贾', '丁', '魏', '薛', '叶', '阎',
            '余', '潘', '杜', '戴', '夏', '钟', '汪', '田', '任', '姜',
            '范', '方', '石', '姚', '谭', '廖', '邹', '熊', '金', '陆',
            '郝', '孔', '白', '崔', '康', '毛', '邱', '秦', '江', '史',
            '顾', '侯', '邵', '孟', '龙', '万', '段', '雷', '钱', '汤',
            '尹', '黎', '易', '常', '武', '乔', '贺', '赖', '龚', '文',

            // 扩展常用姓氏 101-200
            '庞', '樊', '兰', '殷', '施', '陶', '洪', '翟', '安', '颜',
            '倪', '严', '牛', '温', '芦', '季', '俞', '章', '鲁', '葛',
            '伍', '韦', '申', '尤', '毕', '聂', '丛', '焦', '向', '柳',
            '邢', '路', '岳', '齐', '沿', '梅', '莫', '庄', '辛', '管',
            '祝', '左', '涂', '谷', '祁', '时', '舒', '耿', '牟', '卜',
            '路', '詹', '关', '苗', '凌', '费', '纪', '靳', '盛', '童',
            '欧', '甄', '项', '曲', '成', '游', '阳', '裴', '席', '卫',
            '查', '屈', '鲍', '位', '覃', '霍', '翁', '隋', '植', '甘',
            '景', '薄', '单', '包', '司', '柏', '宁', '柯', '阮', '桂',
            '闵', '欧阳', '解', '强', '柴', '华', '车', '冉', '房', '边',

            // 扩展姓氏 201-300
            '辜', '吉', '饶', '刁', '瞿', '戚', '丘', '古', '米', '池',
            '滕', '晋', '苑', '邬', '臧', '畅', '宫', '来', '嵺', '苟',
            '全', '褚', '廉', '简', '娄', '盖', '符', '奚', '木', '穆',
            '党', '燕', '郎', '邸', '冀', '谈', '姬', '屠', '连', '郜',
            '晏', '栾', '郁', '商', '蒙', '计', '喻', '揭', '窦', '迟',
            '宇', '敖', '糜', '鄢', '冷', '卓', '花', '仇', '艾', '蓝',
            '都', '巩', '稽', '井', '练', '仲', '乐', '虞', '卞', '封',
            '竺', '冼', '原', '官', '衣', '楚', '佟', '栗', '匡', '宗',
            '应', '台', '巫', '鞠', '僧', '桑', '荆', '谌', '银', '扬',
            '明', '沙', '薄', '伏', '岑', '习', '胥', '保', '和', '蔺',

            // 少数民族和稀有姓氏
            '云', '亓', '元', '历', '支', '昝', '渠', '轩辕', '令狐',
            '上官', '司马', '东方', '诸葛', '尉迟', '皇甫', '夏侯',
            '慕容', '司徒', '司空', '鲜于', '闾丘', '亓官', '司寇',
            '巫马', '公西', '颛孙', '端木', '漆雕', '乐正', '壤驷',
            '公良', '拓跋', '夹谷', '宰父', '谷梁', '段干', '百里',
            '东郭', '南门', '呼延', '归海', '羊舌', '微生', '梁丘',
            '左丘', '东门', '西门', '南宫', '第五', '言福', '仉', '督'
        ]);

        // 商用级复姓库
        this.compoundSurnames = new Set([
            '欧阳', '司马', '上官', '东方', '诸葛', '尉迟', '皇甫',
            '夏侯', '慕容', '司徒', '司空', '南宫', '端木', '申屠',
            '钟离', '宇文', '长孙', '鲜于', '闾丘', '亓官', '司寇',
            '巫马', '公西', '颛孙', '漆雕', '乐正', '壤驷', '公良',
            '拓跋', '夹谷', '宰父', '谷梁', '段干', '百里', '东郭',
            '南门', '呼延', '归海', '羊舌', '微生', '梁丘', '左丘',
            '东门', '西门', '第五', '言福', '轩辕', '令狐'
        ]);

        this.addressKeywords = new Set([
            '省', '市', '区', '县', '镇', '乡', '村', '街道', '路', '街',
            '巷', '号', '栋', '单元', '楼', '层', '室', '小区', '花园',
            '大厦', '广场', '中心', '城', '苑', '居', '庭', '湾', '国际',
            '公寓', '别墅', '胡同', '里', '弄', '坊', '组团', '街区'
        ]);

        // 增强的姓名识别关键词
        this.nameKeywords = new Set([
            '收件人', '收货人', '联系人', '姓名', '名字', '签收人',
            '先生', '女士', '小姐', '太太', '老师', '教授', '经理',
            '主任', '总', '同志', '同学', '家长', '负责人', '代表',
            '哥哥', '姐姐', '弟弟', '妹妹', '叔叔', '阿姨', '爷爷',
            '奶奶', '外公', '外婆', '伯伯', '舅舅', '姑姑', '姨妈'
        ]);

        // 常见名字后缀（用于提高识别准确率）
        this.nameSuffixes = new Set([
            '先生', '女士', '小姐', '太太', '老师', '教授', '经理',
            '主任', '总', '同志', '同学'
        ]);
    }

    parse(text) {
        if (!text || typeof text !== 'string') {
            return this.getEmptyResult(text);
        }

        const original = text.trim();
        let workingText = original;

        // 提取电话
        const phoneInfo = this.extractPhone(workingText);
        workingText = phoneInfo.remainingText;

        // 分析姓名和地址
        const { name, address } = this.analyzeNameAndAddress(workingText);

        const result = {
            name: name.trim(),
            phone: phoneInfo.phone,
            address: address.trim(),
            province: this.extractProvince(address),
            city: this.extractCity(address),
            district: this.extractDistrict(address),
            detail: this.extractDetail(address),
            original: original
        };

        return result;
    }

    extractPhone(text) {
        // 增强手机号正则（支持带空格的情况）
        const mobileRegex = /(1[3-9]\d[\s-]?\d{4}[\s-]?\d{4})/g;
        // 增强固定电话正则
        const telRegex = /(0\d{2,3}[\s-]?\d{7,8})/g;

        const phones: string[] = [];
        let remainingText = text;

        // 匹配手机号
        let match;
        while ((match = mobileRegex.exec(text)) !== null) {
            const phone = match[0].replace(/[\s-]/g, '');
            phones.push(phone);
            remainingText = remainingText.replace(match[0], ' ');
        }

        // 匹配固定电话
        while ((match = telRegex.exec(text)) !== null) {
            const phone = match[0].replace(/[\s-]/g, '');
            phones.push(phone);
            remainingText = remainingText.replace(match[0], ' ');
        }

        return {
            phone: phones[0] || '',
            phones: phones,
            remainingText: remainingText.replace(/\s+/g, ' ').trim()
        };
    }

    analyzeNameAndAddress(text) {
        if (!text) return { name: '', address: '' };

        let name = '';
        let address = text;

        // 方法1: 使用姓名关键词识别（最高优先级）
        const nameByKeyword = this.extractNameByKeywords(text);
        if (nameByKeyword) {
            name = nameByKeyword;
            address = text.replace(new RegExp(`${this.escapeRegex(nameByKeyword)}[\\s\\S]*?$`), '').trim();
            return { name, address };
        }

        // 方法2: 分析文本结构
        const parts = text.split(/[\s,，;；]+/).filter(part => part.length > 0);

        if (parts.length === 0) {
            return { name: '', address: '' };
        }

        // 方法3: 从开头识别（第二优先级）
        if (this.isLikelyName(parts[0])) {
            name = parts[0];
            address = parts.slice(1).join(' ');
        }
        // 方法4: 从结尾识别
        else if (parts.length >= 2 && this.isLikelyName(parts[parts.length - 1])) {
            name = parts[parts.length - 1];
            address = parts.slice(0, -1).join(' ');
        }
        // 方法5: 扫描所有部分
        else {
            const nameCandidate = this.scanForName(parts);
            if (nameCandidate) {
                name = nameCandidate;
                address = text.replace(nameCandidate, '').replace(/\s+/g, ' ').trim();
            }
        }

        return { name, address };
    }

    // 转义正则特殊字符
    escapeRegex(string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    // 使用关键词识别姓名
    extractNameByKeywords(text) {
        const patterns = [
            // 收件人：张三
            /(?:收件人|收货人|联系人|姓名|名字)[:：]?\s*([\u4e00-\u9fa5]{2,4})/i,
            // 张三 先生
            /([\u4e00-\u9fa5]{2,4})\s*(?:先生|女士|小姐|太太|老师|教授|经理|主任)/,
            // 先生 张三
            /(?:先生|女士|小姐|太太|老师|教授|经理|主任)\s*([\u4e00-\u9fa5]{2,4})/,
            // 张三(先生)
            /([\u4e00-\u9fa5]{2,4})\s*[\(（](?:先生|女士|小姐|太太)[\)）]/,
            // 姓名张三
            /(?:姓名|名字)([\u4e00-\u9fa5]{2,4})/
        ];

        for (const pattern of patterns) {
            const match = text.match(pattern);
            if (match && match[1]) {
                return match[1];
            }
        }

        return null;
    }

    // 扫描所有部分寻找姓名
    scanForName(parts) {
        let bestCandidate = null;
        let bestScore = 0;

        for (const part of parts) {
            if (this.isLikelyName(part)) {
                const score = this.calculateNameScore(part);
                if (score > bestScore) {
                    bestScore = score;
                    bestCandidate = part;
                }
            }
        }

        return bestCandidate;
    }

    isLikelyName(str) {
        if (!str || str.length < 2 || str.length > 4) return false;

        // 必须是中文字符
        const chineseRegex = /^[\u4e00-\u9fa5]+$/;
        if (!chineseRegex.test(str)) return false;

        // 检查是否是复姓
        if (str.length >= 3) {
            const firstTwo = str.substring(0, 2);
            if (this.compoundSurnames.has(firstTwo)) {
                return true;
            }
        }

        // 检查常见姓氏
        return this.commonSurnames.has(str[0]);
    }

    calculateNameScore(name) {
        let score = 0;

        // 长度得分
        if (name.length === 2) score += 30;
        else if (name.length === 3) score += 40; // 3个字最常见
        else if (name.length === 4) score += 25;

        // 姓氏得分
        if (this.commonSurnames.has(name[0])) {
            score += 50;
        }

        // 复姓加分
        if (name.length >= 3 && this.compoundSurnames.has(name.substring(0, 2))) {
            score += 30;
        }

        // 避免将地址关键词识别为姓名
        for (const keyword of this.addressKeywords) {
            if (name.includes(keyword)) {
                score -= 100;
                break;
            }
        }

        return score;
    }

    extractProvince(address) {
        const provinces = [
            '北京市', '天津市', '上海市', '重庆市',
            '河北省', '山西省', '辽宁省', '吉林省', '黑龙江省',
            '江苏省', '浙江省', '安徽省', '福建省', '江西省', '山东省',
            '河南省', '湖北省', '湖南省', '广东省', '海南省', '四川省',
            '贵州省', '云南省', '陕西省', '甘肃省', '青海省',
            '内蒙古自治区', '广西壮族自治区',
        ];

        for (const province of provinces) {
            if (address.includes(province)) {
                return province;
            }
        }

        return '';
    }

    extractCity(address) {
        const cityRegex = /([\u4e00-\u9fa5]+市)/;
        const match = address.match(cityRegex);
        return match ? match[1] : '';
    }

    extractDistrict(address) {
        const districtRegex = /([\u4e00-\u9fa5]+[区县])/;
        const match = address.match(districtRegex);
        return match ? match[1] : '';
    }

    extractDetail(address) {
        let detail = address;
        const province = this.extractProvince(address);
        const city = this.extractCity(address);
        const district = this.extractDistrict(address);

        if (province) detail = detail.replace(province, '');
        if (city) detail = detail.replace(city, '');
        if (district) detail = detail.replace(district, '');

        return detail.replace(/\s+/g, ' ').trim();
    }

    getEmptyResult(original) {
        return {
            name: '',
            phone: '',
            address: '',
            province: '',
            city: '',
            district: '',
            detail: '',
            original: original || ''
        };
    }
}
/**
 * 从收货地址字符串中识别出姓名，手机号，省市区
 * 例如：张三 13800138000 北京市朝阳区建国路100号
 * * @return Promise { 'name': '', 'phone': '', 'area_ids': '', 'address': '' }
 */
export const parseAddress = (baseStr) => {
    return new Promise((resolve, reject) => {
        const parser = new CommercialAddressParser();
        if (!baseStr || !baseStr.trim()) {
            let result = { 'name': '', 'phone': '', 'area_ids': '', 'address': '' }
            resolve(result)
        }
        const result = parser.parse(baseStr);
        let data = {
            'name': result.name,
            'phone': result.phone,
            'area_ids': '',
            'address': result.address
        }
        //处理省市区
        if (result.city && result.district) {
            //根据名称查询省份id
            let requestParam = {
                url: '/admin/getAreasByName',
                method: 'post',
                data: {
                    province: result.province,
                    city: result.city,
                    district: result.district
                }
            }
            baseService(requestParam)
                .then((res: any) => {
                    data.area_ids = res.data.ids
                    data.address = res.data.province_name + data.address
                    resolve(data)
                })
                .catch((res) => {
                    reject('识别失败')
                })
        } else {
            reject('识别失败,未填市区')
        }
    })
}

/**
 * 从字符串中提取金额，单位为万
 * @param str
 */
export const extractAmountInWan = (str) => {
    // 匹配数字（包括小数）和可能的单位
    const match = str.match(/(\d+(\.\d+)?)/);
    if (match) {
        const number = parseFloat(match[1]);
        // 如果字符串中包含"亿"，转换为万元（1亿=10000万元）
        if (str.includes('亿')) {
            return number * 10000;
        }
        // 如果字符串中包含"万"，直接返回数字
        if (str.includes('万')) {
            return number;
        }
        // 如果没有单位，假设是元，转换为万元
        return number / 10000;
    }
    return 0;
}
